/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../message/message.component.ngfactory';
import * as import2 from '../message/message.component';
import * as import3 from '../notification.service';
import * as import4 from '@angular/common';
import * as import5 from './footer-messages.component';
const styles_FooterMessagesComponent:any[] = ([] as any[]);
export const RenderType_FooterMessagesComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_FooterMessagesComponent,
  data: {}
}
);
function View_FooterMessagesComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_FooterMessageComponent_0,import1.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import2.FooterMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
      ,{message: [
        0,
        'message'
      ]
    },(null as any)),
    import0.ɵqud(603979776,1,{links: 1})
  ]
  ,(ck,v) => {
    const currVal_8:any = v.context.$implicit;
    ck(v,1,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_FooterMessagesComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FooterMessagesComponent_2)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.notificationService.footerMessages;
    ck(v,3,0,currVal_0);
  },(null as any));
}
export function View_FooterMessagesComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FooterMessagesComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n'])),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.FooterMessagesComponent = v.component;
    const currVal_0:any = co.showDynamicMessages;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_FooterMessagesComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-footer-messages',([] as any[]),(null as any),(null as any),(null as any),View_FooterMessagesComponent_0,RenderType_FooterMessagesComponent)),
    import0.ɵdid(49152,(null as any),0,import5.FooterMessagesComponent,[
      import3.NotificationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const FooterMessagesComponentNgFactory:import0.ComponentFactory<import5.FooterMessagesComponent> = import0.ɵccf('woa-footer-messages',import5.FooterMessagesComponent,View_FooterMessagesComponent_Host_0,{},{},[
  'woa-footer-message',
  '[slot=messages]'
]
);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/notification/footer-messages/footer-messages.component.ngfactory.ts